module.exports = __webpack_public_path__ + "static/media/covid.fcc2e860.png";